import { animate } from 'framer-motion'
import { startTransition } from 'preact/compat'
import { useEffect, useState } from 'preact/hooks'

interface AnimatedNumberProps {
  value: number
  duration?: number
  transform?: (value: number) => number | string
}

export function AnimatedNumber({ value, duration = 250, transform = (x) => x }: AnimatedNumberProps) {
  const [number, setNumber] = useState(value)

  useEffect(() => {
    const control = animate(number, value, {
      duration: duration / 1000,
      onUpdate(latest) {
        startTransition(() => {
          setNumber(latest)
        })
      },
    })
    return control.stop
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value, duration])
  return <>{transform(number)}</>
}
